// extracted by mini-css-extract-plugin
export default {"editNickname":"editNickName_editNickname__Q5GJR","usernameInput":"editNickName_usernameInput__lvAPo","buttonBox":"editNickName_buttonBox__SgR22"};